// @ts-nocheck
import { combineReducers } from "redux";
import auth from "./auth";
import router from "./router";
import posts from "./posts";
import organizations from "./organizationReducers";
import divisions from "./divisionReducers";
import teams from "./teamReducers";
import teamDivisions from "./teamDivisionReducers";
import searchResults from "./searchReducers";
import games from "./gameReducers";
import players from "./playerReducers";
import stats from "./statReducers";
import settings from "./settingReducers";
import leagues from "./leagueReducers";
import user from "./userReducers";
import ui from "./uiReducers";
import globalState from "./globalReducers";
import aggregateStats from "./aggregateStatsReducers";
import layouts from "./layoutReducers";
import registrationTeams from "./registrationTeamReducers";

export default combineReducers({
  auth,
  router,
  posts,
  organizations,
  divisions,
  teams,
  teamDivisions,
  games,
  players,
  settings,
  stats,
  leagues,
  user,
  ui,
  globalState,
  aggregateStats,
  layouts,
  registrationTeams,
  searchResults
});
